module.exports = __webpack_public_path__ + "img/nest-1.da266d82.png";